<template>
	<div>
        <div class="col-5 mb-4">
            <h1>Greedo's {{ $t("reflective-log") }}</h1> 
        </div>
        <div class="row">
            <div class="col-12 col-lg-8">
                <transition-group name="fade">
                    <div v-for="post in sortedPosts" :key="post.id" class="list-group border-radius-2 mt-1">
                        <div class="list-group-item">
                            <div class="d-flex ">
                                <strong>{{ post.author_id }}</strong>
                                <p class="ml-auto">{{ formatDate(post.date) }}</p>
                            </div>
                            {{ post.content }}
                            <div class="d-flex mt-1">
                                <div class="col text-center">
                                    <b-icon icon="chat" class="mx-1"></b-icon>
                                </div>
                                <div class="col text-center">
                                    <b-icon icon="star" class="mx-1"></b-icon>{{ post.likes }}
                                </div>
                                <div class="col text-center">
                                    <b-icon icon="share" class="mx-1"></b-icon>
                                </div>
                                <div class="col text-center">
                                    <b-icon icon="three-dots" class="mx-1"></b-icon>
                                </div>
                            </div> 
                        </div>
                    </div>
                </transition-group>    
            </div>
            <div class="col-12 col-lg-4">
                <div class="list-group border-radius-2">
                    <div class="list-group-item">
                        <h3>Widget</h3>
                        <p >Something useful goes here</p>
                    </div>
                </div>     
                <div class="list-group border-radius-2 mt-1">
                    <div class="list-group-item list-group-header">
                        <h3>Popular posts</h3>
                    </div>
                    <div class="list-group-item"  v-for="post in popPosts" :key="post.id">
                        <div class="d-flex">
                            <strong>{{ post.author_id }}</strong>
                            <p class="ml-auto">{{ formatDate(post.date) }}</p>
                        </div>
                        {{ post.content }}
                        <div class="d-flex mt-1">
                            <div class="col text-center">
                                <b-icon icon="star" class="mx-1"></b-icon>{{ post.likes }}
                            </div>
                        </div> 
                    </div>
                </div>     
            </div>
        </div>
	</div>
</template>			
<script>
//import { VEmojiPicker } from "v-emoji-picker";
export default {
    data() {
        return {
            posts: [
                {
                    author_id: "Greedo",//this should be an integer
                    id: 1,
                    content: 'It is well-known that Han shot first.',
                    likes: 100,
                
                },
                {
                    author_id: "User B",
                    id: 2,
                    content: 'Why do people call them buildings instead of builts?',
                    likes: 10,
                
                },
                {
                    author_id: "Get ready for reality, get ready for the pain",
                    id: 3,
                    content: 'Strawberries are not berries, we have been living a lie.',
                    likes: 2
                
                },
                {
                    author_id: "Greedo",
                    id: 4,
                    content: 'Going to Mos Eisley with the boys, feeling wild!',
                    likes: 3
                
                },
            ],
            popPosts: [
                {
                    author_id: "Chewbacca",//this should be an integer
                    id: 1,
                    content: 'RRAAAAAAAARRRRRWWWWW...',
                    likes: 100
                
                },
                {
                    author_id: "The Emperor",
                    id: 2,
                    content: 'Just joined the Conservative party, what a...',
                    likes: 0
                
                },
                {
                    author_id: "Yoda",
                    id: 3,
                    content: 'Do or do not, there is no try.',
                    likes: 2
                
                },
                {
                    author_id: "Darth Vader",//this should be an integer
                    id: 4,
                    content: 'A group of teenagers just blew the Death Star...',
                    likes: 3
                
                },
            ],
            };
    },
    created() {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);

        this.posts.forEach(post => {
        post.date = yesterday.toDateString();
        });
        this.popPosts.forEach(post => {
        post.date = yesterday.toDateString();
        });
    },
    methods: {
        formatDate(timestamp) {
            const date = new Date(timestamp);
            return date.toLocaleDateString(); 
        },
        },
    computed: {
        sortedPosts() {
            return this.posts.slice().reverse();
        }
    },
  
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>





